import styled from 'styled-components';

interface Props {
  title: string;
  desc: string;
  link: string;
  img: string;
  color: string;
}

function OtherServiceCard({ title, desc, link, img, color }: Props) {
  return (
    <Card onClick={() => window.open(link, '_blank')}>
      <CardImgWrapper $bg={color}>
        <img src={`/assets/images/guide-landing/${img}.png`} alt="" />
      </CardImgWrapper>
      <CardBody>
        <CardContent>
          <CardTitle>{title}</CardTitle>
          <CardDesc>{desc}</CardDesc>
        </CardContent>
        <ButtonWrapper>
          <Button>
            바로가기
            <ArrowButton>
              <img src="/assets/images/arrow/arrow-right-purple.svg" alt="" />
            </ArrowButton>
          </Button>
        </ButtonWrapper>
      </CardBody>
    </Card>
  );
}

export default OtherServiceCard;

const ArrowButton = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 20px;
  background: var(--semantic-static-white, #fff);

  /* &:hover {
    background: #f2f2ff;
  }
  &:active {
    background: #c7c4ff;
  } */

  & > img {
    width: 20px;
    height: 20px;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  border-radius: 24px;
  background: #fff;
  cursor: pointer;

  &:hover ${ArrowButton} {
    background: #f2f2ff;
  }

  &:active ${ArrowButton} {
    background: #c7c4ff;
  }
`;

const CardImgWrapper = styled.div<{ $bg?: string }>`
  background-color: ${({ $bg }) => $bg};
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  & > img {
    width: 100%;
    height: auto;
  }
`;

const CardBody = styled.div`
  display: flex;
  padding: 16px 24px 24px 24px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const CardTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const CardDesc = styled.div`
  color: #616161;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.3px;
  white-space: pre-line;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #1f0a8a;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;
